import {getPath} from '@epic-core/common';
import {getLocalePath} from 'epic-ue-locale-mode';
import React from 'react';
import {Redirect} from './Redirect';
import {ServerRoute} from './routes';
import {getOnlineLearningRedirects} from './onlineLearningRedirects';
import {getReleaseNotesRedirects} from './releaseNotesRedirects';
import {getTwinmotionRedirects} from './twinmotionRedirects';
import {getMetahumanRedirects} from './metahumanRedirects';
import root from 'window-or-global';

export const getAppRedirects = (): ServerRoute[] => {
    const path = getPath();
    const localePath = getLocalePath();
    const onlineLearningRedirects = getOnlineLearningRedirects();
    const releaseNotesRedirects = onlineLearningRedirects.concat(getReleaseNotesRedirects());
    const twinmotionRedirects = releaseNotesRedirects.concat(getTwinmotionRedirects());
    const metahumanRedirects = twinmotionRedirects.concat(getMetahumanRedirects());

    const clientConfig = root.clientEnvConfig || {};
    const EPIC_SERVER_URL = clientConfig && clientConfig.EPIC_SERVER_URL;
    if (!EPIC_SERVER_URL) {
        throw new Error('routes missing EPIC_SERVER_URL');
    }
    const serverUrl = EPIC_SERVER_URL;

    return metahumanRedirects.concat([
        {
            path: `${localePath}/branding`,
            element: (
                <Redirect url="https://brand.epicgames.com/unreal-engine" status={301} replace />
            )
        },
        {
            path: `${localePath}/bridge`,
            element: <Redirect url="https://www.quixel.com" status={301} replace />
        },
        {
            path: `${localePath}/virtual-production`,
            element: <Redirect to="/uses/film-television" status={301} />
        },
        {
            path: `${localePath}/solutions/games/indie-games`,
            element: <Redirect to="/uses/indie-games" status={301} />
        },
        {
            path: `${localePath}/solutions/games/mobile-games`,
            element: <Redirect to="/uses/mobile-games" status={301} />
        },
        {
            path: `${localePath}/uses/games/indie-games`,
            element: <Redirect to="/uses/indie-games" status={301} />
        },
        {
            path: `${localePath}/uses/games/mobile-games`,
            element: <Redirect to="/uses/mobile-games" status={301} />
        },
        {
            path: `${localePath}/uses/automotive-transportation`,
            element: <Redirect to="/uses/automotive" status={301} />
        },
        {
            path: `${localePath}/solutions/more-uses`,
            element: <Redirect to="/" status={301} />
        },
        {
            path: `${localePath}/uses/more-uses`,
            element: <Redirect to="/" status={301} />
        },
        {
            path: `${localePath}/solutions/:title`,
            element: <Redirect to="/uses/:title" status={301} />
        },
        {
            path: `${localePath}/metahuman-creator`,
            element: (
                <Redirect
                    url="https://www.metahuman.com/:locale/creator-download"
                    status={301}
                    replace
                />
            )
        },
        {
            path: `${localePath}/unreal`,
            element: <Redirect to="/unreal-engine-5" />
        },
        {
            path: `${localePath}/login`,
            element: <Redirect url={`${serverUrl}/login`} replace />
        },
        {
            path: `${localePath}/custom-license`,
            element: <Redirect to="/license#contact-us-form" status={301} replace omitSearch />
        },
        {
            path: `${localePath}/custom-licensing`,
            element: <Redirect to="/license#contact-us-form" status={301} replace />
        },
        {
            path: `${localePath}/blog/parent-verification-tools-now-free-for-developers-download-now`,
            element: (
                <Redirect
                    url="https://www.kidswebservices.com/:locale/news/free-parent-verification"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/blog/humber-college-draws-attention-to-real-issues-with-unreal-engine`,
            element: (
                <Redirect to="/blog/humber-college-uses-unreal-engine-to-shed-light-on-important-issues" />
            )
        },
        {
            path: `${localePath}/blog/oodle-now-available-in-unreal-engine-4-27-through-github-access`,
            element: <Redirect to="/blog/oodle-now-free-to-use-in-unreal-engine-via-github" />
        },
        {
            path: `${localePath}/blog/epic-online-services-launches-two-new-free-services`,
            element: (
                <Redirect
                    url="https://dev.epicgames.com/:locale/news/epic-online-services-launches-two-new-free-services"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/blog/epic-online-services-featuring-epic-account-and-game-services`,
            element: (
                <Redirect
                    url="https://dev.epicgames.com/:locale/news/epic-online-services-featuring-epic-account-and-game-services"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/eula-reference/creators-ru`,
            element: <Redirect to="/eula/unreal" status={301} />
        },
        {
            path: `${localePath}/eula-reference/publishing-ru`,
            element: <Redirect to="/eula/unreal" status={301} />
        },
        {
            path: `${localePath}/eula-reference/creators-pt-br`,
            element: <Redirect to="/eula/unreal" status={301} />
        },
        {
            path: `${localePath}/eula-reference/publishing-pt-br`,
            element: <Redirect to="/eula/unreal" status={301} />
        },
        {
            path: `${localePath}/eula-reference/creators-ja`,
            element: <Redirect to="/eula-reference/unreal-ja" status={301} />
        },
        {
            path: `${localePath}/eula-reference/publishing-ja`,
            element: <Redirect to="/eula-reference/unreal-ja" status={301} />
        },
        {
            path: `${localePath}/eula-reference/creators-ko`,
            element: <Redirect to="/eula-reference/unreal-ko" status={301} />
        },
        {
            path: `${localePath}/eula-reference/publishing-ko`,
            element: <Redirect to="/eula-reference/unreal-ko" status={301} />
        },
        {
            path: `${localePath}/eula-reference/creators-zh-cn`,
            element: <Redirect to="/eula-reference/unreal-zh-cn" status={301} />
        },
        {
            path: `${localePath}/eula-reference/publishing-zh-cn`,
            element: <Redirect to="/eula-reference/unreal-zh-cn" status={301} />
        },
        {
            path: `${localePath}/eulacheck/creators`,
            element: <Redirect to="/eulacheck/unreal" status={301} />
        },
        {
            path: `${localePath}/eulacheck/publishing`,
            element: <Redirect to="/eulacheck/unreal" status={301} />
        },
        {
            path: `${localePath}/eulaprompt/creators`,
            element: <Redirect to="/eulaprompt/unreal" status={301} />
        },
        {
            path: `${localePath}/eulaprompt/publishing`,
            element: <Redirect to="/eulaprompt/unreal" status={301} />
        },
        {
            path: `${localePath}/eula-change-log/publishing`,
            element: <Redirect to="/eula-change-log/unreal" status={301} />
        },
        {
            path: `${localePath}/eula-change-log/creators`,
            element: <Redirect to="/eula-change-log/unreal" status={301} />
        },
        {
            path: `${localePath}/eula/publishing`,
            element: <Redirect to="/eula/unreal" status={301} replace />
        },
        {
            path: `${localePath}/eula/creators`,
            element: <Redirect to="/eula/unreal" status={301} replace />
        },
        {
            path: `${localePath}/animation`,
            element: <Redirect to="/uses/animation" status={301} />
        },
        {
            path: `${localePath}/broadcast`,
            element: <Redirect to="/uses/broadcast-live-events" status={301} />
        },
        {
            path: `${localePath}/hmi`,
            element: <Redirect to="/uses/hmi" status={301} />
        },
        {
            path: `${localePath}/uses/project-anywhere`,
            element: <Redirect to="/project-anywhere" status={301} />
        },
        {
            path: `${localePath}/games`,
            element: <Redirect to="/uses/games" />
        },
        {
            path: `${localePath}/automotive`,
            element: <Redirect to="/uses/automotive-transportation" />
        },
        {
            path: `${localePath}/media-entertainment`,
            element: <Redirect to="/uses/film-television" />
        },
        {
            path: `${localePath}/film-tv`,
            element: <Redirect to="/uses/film-television" />
        },
        {
            path: `${localePath}/simulations`,
            element: <Redirect to="/uses/simulation" />
        },
        {
            path: `${localePath}/training-simulation`,
            element: <Redirect to="/uses/simulation" />
        },
        {
            path: `${localePath}/uses/training-simulation`,
            element: <Redirect to="/uses/simulation" status={301} />
        },
        {
            path: `${localePath}/architecture`,
            element: <Redirect to="/uses/architecture" />
        },
        {
            path: `${localePath}/industry/digital-twins`,
            element: <Redirect to="/digital-twins" />
        },
        {
            path: `${localePath}/digital-humans`,
            element: <Redirect to="/metahuman" status={301} replace />
        },
        {
            path: `${localePath}/gdc2018`,
            element: <Redirect to="/events/gdc2018" status={301} />
        },
        {
            path: `${localePath}/thepulse`,
            element: <Redirect to="/events/the-pulse" status={301} />
        },
        {
            path: `${localePath}/vp-week`,
            element: <Redirect to="/events/virtual-production-week-2022" />
        },
        {
            path: `${localePath}/webinars`,
            element: <Redirect to="/events/webinar-series" />
        },
        {
            path: `${localePath}/events/enterprise-webinar-series`,
            element: <Redirect to="/events/webinar-series" />
        },
        {
            path: `${localePath}/BA21`,
            element: <Redirect to="/events/build-architecture-2021" status={301} />
        },
        {
            path: `${localePath}/ba21`,
            element: <Redirect to="/events/build-architecture-2021" status={301} />
        },
        {
            path: `${localePath}/future-of-animation`,
            element: <Redirect to="/events/future-of-animation" status={301} />
        },
        {
            path: `${localePath}/viitsec2020`,
            element: <Redirect to="/events/viitsec2020" status={301} />
        },
        {
            path: `${localePath}/account-help`,
            element: <Redirect url="http://help.epicgames.com" status={301} />
        },
        {
            path: `${localePath}/register`,
            element: <Redirect to="/download" status={301} />
        },
        {
            path: `${localePath}/download/creators`,
            element: <Redirect to="/download" status={301} />
        },
        {
            path: `${localePath}/download/publishing`,
            element: <Redirect to="/download" status={301} />
        },
        {
            path: `${localePath}/showcase/:title`,
            element: <Redirect to="/blog/:title" status={301} />
        },
        {
            path: `${localePath}/showcase/:articleLocale/:title`,
            element: <Redirect to="/blog/:title" status={301} />
        },
        {
            path: `${localePath}/enterprise/news`,
            element: <Redirect to="/feed?tags=news" status={301} />
        },
        {
            path: `${localePath}/enterprise/news/:title`,
            element: <Redirect to="/blog/:title" status={301} />
        },
        {
            path: `${localePath}/enterprise/blog/:title`,
            element: <Redirect to="/blog/:title" status={301} />
        },
        {
            path: `${localePath}/enterprise/blog`,
            element: <Redirect to="/feed?tags=news" status={301} />
        },
        {
            path: `${localePath}/home`,
            element: <Redirect to="/" status={301} />
        },
        {
            path: `${localePath}/news`,
            element: <Redirect to="/feed?tags=news" />
        },
        {
            path: `${localePath}/showcase`,
            element: <Redirect to="/feed" status={301} />
        },
        {
            path: `${localePath}/blog/category/:category`,
            element: <Redirect to="/feed" status={301} />
        },
        {
            path: `${localePath}/video-tutorials`,
            element: <Redirect url="https://learn.unrealengine.com" status={301} />
        },
        {
            path: `${localePath}/console-request`,
            element: (
                <Redirect
                    url="https://epicgames.secure.force.com/Forms/FormConsoleAccessRequest"
                    status={301}
                />
            )
        },
        {
            path: `${localePath}/unrealdevgrants`,
            element: <Redirect to="/megagrants" status={301} />
        },
        {
            path: `${localePath}/programs/virtual-production`,
            element: <Redirect to="/virtual-production" />
        },
        {
            path: `${localePath}/vr`,
            element: <Redirect to="/xr" status={301} replace />
        },
        {
            path: `${localePath}/ar`,
            element: <Redirect to="/xr" status={301} replace />
        },
        {
            path: `${localePath}/student-showcase`,
            element: <Redirect to="/events/student-showcase" status={301} />
        },
        {
            path: `${localePath}/blog`,
            element: <Redirect to="/feed" status={301} />
        },
        {
            path: `${localePath}/feed/news`,
            element: <Redirect to="/feed?tags=news" status={301} />
        },
        {
            path: `${localePath}/industries/automotive`,
            element: <Redirect to="/uses/automotive-transportation" status={301} replace />
        },
        {
            path: `${localePath}/industries/media-entertainment`,
            element: <Redirect to="/uses/film-television" />
        },
        {
            path: `${localePath}/industries/:industry`,
            element: <Redirect to="/uses/:industry" replace />
        },
        {
            path: `${localePath}/industry/:industry`,
            element: <Redirect to="/uses/:industry" status={301} replace />
        },
        {
            path: `${localePath}/industries`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/industry`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/eula/realityscan`,
            element: <Redirect url="https://www.realityscan.com/:locale/eula-mobile" status={301} />
        },
        {
            path: `${localePath}/eula-reference`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/eula-chn`,
            element: <Redirect to="/eula-reference/unreal-zh-cn" status={301} replace />
        },
        {
            path: `${localePath}/eula-japanese`,
            element: <Redirect to="/eula-reference/unreal-ja" status={301} replace />
        },
        {
            path: `${localePath}/eula-ko`,
            element: <Redirect to="/eula-reference/unreal-ko" status={301} replace />
        },
        {
            path: `${localePath}/events/secondary-accelerator`,
            element: <Redirect to="/educators/accelerator" status={301} replace />
        },
        {
            path: `${localePath}/korean-eula`,
            element: <Redirect to="/eula-reference/unreal-ko" status={301} replace />
        },
        {
            path: `${localePath}/eula-portuguese-br`,
            element: <Redirect to="/eula-reference/publishing-pt-br" status={301} replace />
        },
        {
            path: `${localePath}/eula-ru`,
            element: <Redirect to="/eula-reference/publishing-ru" status={301} replace />
        },
        {
            path: `${localePath}/service-partners`,
            element: <Redirect to="/service-partner-program" status={301} replace />
        },
        {
            path: `${localePath}/academic-partners`,
            element: <Redirect url="https://www.artstation.com/schools" status={301} />
        },
        {
            path: `${localePath}/training-partners`,
            element: <Redirect url="https://www.artstation.com/schools" status={301} />
        },
        {
            path: `${localePath}/showdown-eula`,
            element: <Redirect to="/eula/showdown" status={301} replace />
        },
        {
            path: `${localePath}/bullet-train/eula`,
            element: <Redirect to="/eula/bullet-train" status={301} replace />
        },
        {
            path: `${localePath}/studio/eula`,
            element: <Redirect to="/eula/creators" status={301} replace />
        },
        {
            path: `${localePath}/studio/eula-chn`,
            element: <Redirect to="/eula-reference/creators-zh-cn" status={301} replace />
        },
        {
            path: `${localePath}/architecture-solution`,
            element: <Redirect to="/uses/architecture" />
        },
        {
            path: `${localePath}/uses/more`,
            element: <Redirect to="/uses/more-uses" status={301} replace />
        },
        {
            path: `${localePath}/uses`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/ue4-on-github`,
            element: <Redirect to="/ue-on-github" status={301} />
        },
        {
            path: `${localePath}/ue5`,
            element: <Redirect to="/unreal-engine-5" status={301} />
        },
        {
            path: `${localePath}/what-is-unreal-engine-4`,
            element: <Redirect to="/unreal" status={301} />
        },
        {
            path: `${localePath}/unreal-engine-4`,
            element: <Redirect to="/unreal" status={301} />
        },
        {
            path: `${localePath}/products/unreal-engine-4`,
            element: <Redirect to="/unreal" status={301} />
        },
        {
            path: `${localePath}/products/unreal-engine-3`,
            element: <Redirect to="/unreal" status={301} />
        },
        {
            path: `${localePath}/products`,
            element: <Redirect to="/unreal" />
        },
        {
            path: `${localePath}/user-groups`,
            element: <Redirect url="https://communities.unrealengine.com" status={301} />
        },
        {
            path: `${localePath}/education`,
            element: <Redirect to="/learn" status={301} />
        },
        {
            path: `${localePath}/academic-admins`,
            element: <Redirect to="/learn" status={301} />
        },
        {
            path: `${localePath}/resources`,
            element: <Redirect to="/guides-and-white-papers" status={301} />
        },
        {
            path: `${localePath}/get-now/*`,
            element: <Redirect to="/download" status={301} />
        },
        {
            path: `${localePath}/get-now`,
            element: <Redirect to="/download" status={301} />
        },
        {
            path: `${localePath}/eulacheck`,
            element: <Redirect to="/eulacheck/unreal" />
        },
        {
            path: `${localePath}/eulaprompt`,
            element: <Redirect to="/eulaprompt/unreal" />
        },
        {
            path: `${localePath}/eula`,
            element: <Redirect to="/eula/unreal" replace />
        },
        {
            path: `${localePath}/stack-o-bot`,
            element: <Redirect url="https://www.unrealengine.com/marketplace/product/stack-o-bot" />
        },
        // TODO: Hardcoded locale routes — update for locale mode "never" support
        {
            path: `${path}en-US/marketplace-guidelines`,
            element: (
                <Redirect url="https://support.fab.com/s/article/FAB-TECHNICAL-REQUIREMENTS/?language=en_US" />
            )
        },
        {
            path: `${path}zh-CN/marketplace-guidelines`,
            element: (
                <Redirect url="https://support.fab.com/s/article/FAB-TECHNICAL-REQUIREMENTS/?language=zh_CN" />
            )
        },
        {
            path: `${path}ko/marketplace-guidelines`,
            element: (
                <Redirect url="https://support.fab.com/s/article/FAB-TECHNICAL-REQUIREMENTS/?language=ko" />
            )
        },
        {
            path: `${path}ja/marketplace-guidelines`,
            element: (
                <Redirect url="https://support.fab.com/s/article/FAB-TECHNICAL-REQUIREMENTS/?language=ja" />
            )
        },
        {
            path: `${path}en-US/marketplace-faq`,
            element: (
                <Redirect url="https://support.fab.com/s/?language=en_US&ProductOrigin=FabSupport" />
            )
        },
        {
            path: `${path}zh-CN/marketplace-faq`,
            element: (
                <Redirect url="https://support.fab.com/s/?language=zh_CN&ProductOrigin=FabSupport" />
            )
        },
        {
            path: `${path}ko/marketplace-faq`,
            element: (
                <Redirect url="https://support.fab.com/s/?language=ko&ProductOrigin=FabSupport" />
            )
        },
        {
            path: `${path}ja/marketplace-faq`,
            element: (
                <Redirect url="https://support.fab.com/s/?language=ja&ProductOrigin=FabSupport" />
            )
        },
        {
            path: `${localePath}/support/contact-epic`,
            element: <Redirect to="/support" status={301} />
        },
        {
            path: `${localePath}/support/contribute`,
            element: <Redirect to="/support" status={301} />
        },
        {
            path: `${localePath}/support/custom-license`,
            element: <Redirect to="/support" status={301} />
        },
        {
            path: `${localePath}/support/support-faq`,
            element: <Redirect to="/support" status={301} />
        },
        {
            path: `${localePath}/support/support-resources`,
            element: <Redirect to="/support" status={301} />
        },
        {
            path: `${localePath}/support/contact`,
            element: <Redirect to="/support" status={301} />
        },
        {
            path: `${localePath}/contact`,
            element: <Redirect to="/support" status={301} />
        },
        {
            path: `${localePath}/developer-interviews`,
            element: <Redirect to="/feed?tags=interviews" />
        },
        {
            path: `${localePath}/tech-blog`,
            element: <Redirect to="/feed?tags=tech-blog" />
        },
        {
            path: `${localePath}/spotlights`,
            element: <Redirect to="/feed?tags=spotlight" />
        },
        {
            path: `${localePath}/enterprise/contact-us`,
            element: <Redirect to="/license" />
        },
        {
            path: `${localePath}/programs`,
            element: <Redirect to="/feed" />
        },
        {
            path: `${localePath}/events`,
            element: <Redirect to="/feed?tags=events" />
        },
        {
            path: `${localePath}/enterprise`,
            element: <Redirect to="/license" />
        },
        {
            path: `${localePath}/studio/features/:title`,
            element: <Redirect to="/features/:title" status={301} />
        },
        {
            path: `${localePath}/studio/features`,
            element: <Redirect to="/features" status={301} />
        },
        {
            path: `${localePath}/features/:title`,
            element: <Redirect to="/features" status={301} />
        },
        {
            path: `${localePath}/studio`,
            element: <Redirect to="/plugins" status={301} />
        },
        {
            path: `${localePath}/studio/downloads`,
            element: <Redirect to="/plugins" status={301} />
        },
        {
            path: `${localePath}/datasmith`,
            element: <Redirect to="/plugins" status={301} />
        },
        {
            path: `${localePath}/datasmith/plugins`,
            element: <Redirect to="/plugins" status={301} />
        },
        {
            path: `${localePath}/eula-change-log`,
            element: <Redirect to="/eula-change-log/unreal" />
        },
        {
            path: `${localePath}/academy`,
            element: <Redirect to="/learn" />
        },
        {
            path: `${localePath}/classroom-training`,
            element: <Redirect to="/training" />
        },
        {
            path: `${localePath}/programs/unreal-indies`,
            element: <Redirect to="/unreal-indies" status={301} />
        },
        {
            path: `${localePath}/programs/unreal-indies/*`,
            element: <Redirect to="/unreal-indies" status={301} />
        },
        {
            path: `${localePath}/indies`,
            element: <Redirect to="/unreal-indies" status={301} replace />
        },
        {
            path: `${localePath}/indie`,
            element: <Redirect to="/unreal-indies" status={301} replace />
        },
        {
            path: `${localePath}/gdc2020`,
            element: <Redirect to="/events/gdc2020" status={301} />
        },
        {
            path: `${localePath}/gdc2019`,
            element: <Redirect to="/events/gdc2019" status={301} />
        },
        {
            path: `${localePath}/gdc2018`,
            element: <Redirect to="/events/gdc2018" status={301} />
        },
        {
            path: `${localePath}/siggraph2019`,
            element: <Redirect to="/events/siggraph-2019" status={301} />
        },
        {
            path: `${localePath}/unrealfestonline`,
            element: <Redirect to="/events/unreal-fest-online-2020" status={301} />
        },
        {
            path: `${localePath}/e32019`,
            element: <Redirect to="/events/e32019" status={301} />
        },
        {
            path: `${localePath}/ufe2019`,
            element: <Redirect to="/events/unreal-fest-europe-2019" status={301} />
        },
        {
            path: `${localePath}/au2019`,
            element: <Redirect to="/events/autodesk-university-2019" status={301} />
        },
        {
            path: `${localePath}/html5`,
            element: <Redirect to="/" status={301} />
        },
        {
            path: `${localePath}/products/unreal-engine-4`,
            element: <Redirect to="/previous-versions" status={301} />
        },
        {
            path: `${localePath}/products/udk`,
            element: <Redirect to="/previous-versions" status={301} />
        },
        {
            path: `${localePath}/udk`,
            element: <Redirect to="/previous-versions" status={301} />
        },
        {
            path: `${localePath}/products`,
            element: <Redirect to="/previous-versions" status={301} />
        },
        {
            path: `${localePath}/uesc`,
            element: <Redirect to="/fabfreecontent" status={301} />
        },
        {
            path: `${localePath}/uesponsoredcontent`,
            element: <Redirect to="/fabfreecontent" status={301} />
        },
        {
            path: `${localePath}/nvidiaedge`,
            element: <Redirect to="/programs/nvidia-edge" status={301} />
        },
        {
            path: `${localePath}/programs/nvidia-edge-program`,
            element: <Redirect to="/programs/nvidia-edge" status={301} replace />
        },
        {
            path: `${localePath}/awards-accolades`,
            element: <Redirect to="/awards" status={301} />
        },
        {
            path: `${localePath}/education/students`,
            element: <Redirect to="/students" status={301} />
        },
        {
            path: `${localePath}/education/academic-admins`,
            element: <Redirect to="/learn" status={301} />
        },
        {
            path: `${localePath}/ja/blog`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/zh-CN/blog`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/ko/blog`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/ja`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/ko`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/zh-CN`,
            element: <Redirect to="/" />
        },
        {
            path: `${localePath}/free-download/:slug`,
            element: <Redirect to="/try-free/:slug" status={301} />
        },
        {
            path: `${localePath}/download/:slug`,
            element: <Redirect to="/download" status={301} />
        },
        {
            path: `${localePath}/realityscan`,
            element: <Redirect url="https://www.realityscan.com" status={301} />
        }
    ]);
};
